import { Dispatch } from 'redux';
import { AppState } from '../redux';

export const initiateLogin = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {  
    const url = document.location!!.href;
    let loadUrl = url;
    var cnt = 0;
    var ind = 0;
    while (cnt !== 3) {
        ind = loadUrl.indexOf('/', ind) + 1;
        cnt++;
    }
    loadUrl = loadUrl.substring(0, ind); 

    const callbackUrl = loadUrl;        
    let responseType: string | undefined = getState().environment.CIP_RESPONSE_TYPE;
    responseType = responseType!!.split('-').join(' ');
    const loginUrl = `${getState().environment.CIP_LOGIN_URL}` +
                    `?client_id=${getState().environment.CIP_CLIENT_ID}` +
                    `&redirect_uri=${callbackUrl}callback` +
                    `&response_type=${responseType}` +
                    `&scope=app.esim_support`;

    window.location.replace(loginUrl || '');
};



// WEBPACK FOOTER //
// ./src/actions/userAction.ts